import { styled } from 'next-yak';

import { TextButton } from '@xing-com/button';

export const DiscoverAction = styled(TextButton)`
  && {
    justify-content: normal;
  }
`;
